export enum OutputFinishState {
  Finish,
  Interrupt,
  Switch
}
